<!-- noAutoComplete: sin buscador. La lista son unas pocas semanas, y el input de
     búsqueda de ngx-select vaciaba la etiqueta y ensanchaba el control al abrirlo
     (mismo criterio que los selects de producto del flujo). -->
<ngx-select *ngIf="!multiWeeks" [allowClear]="false" [noAutoComplete]="true" [items]="items" optionValueField="value"
    optionTextField="name" [disabled]="ngxDisabled" [(ngModel)]="week" placeholder="Seleccionar Semana"
    (select)="changeWeek($event)">
</ngx-select>

<!-- multiWeeks (flujo de pipas, 16-oct): varias semanas a la vez con casillas,
     «Todas las semanas» / «Ninguna» en la primera fila. Mismo componente que el
     filtro de Productos del flujo (app-multiselect-product): en una línea, con
     la primera semana y «+N». ngx-select en modo múltiple apilaba chips y dejaba
     un buscador vacío debajo.
     OJO: eventos propios (onSelect…) y NO (ngModelChange): el writeValue de este
     componente vuelve a emitir el cambio, y publicar las semanas lo reescribe —
     con ngModelChange se ciclaba y congelaba la vista. -->
<ng-multiselect-dropdown *ngIf="multiWeeks" class="select-week-multi" [placeholder]="'Ninguna semana'"
    [settings]="multiSettings" [data]="multiItems" [disabled]="ngxDisabled" [(ngModel)]="multiSelected"
    (onSelect)="changeWeeks(multiSelected)" (onDeSelect)="changeWeeks(multiSelected)"
    (onSelectAll)="changeWeeks($event)" (onDeSelectAll)="changeWeeks([])">
</ng-multiselect-dropdown>
